import { dispose } from './dispose';
import { mute } from './mute';
import { setVolume } from './setVolume';
import { unmute } from './unmute';

export const volumeNode = {
  dispose,
  mute,
  setVolume,
  unmute,
};
